import { render } from "./IconDoubleCheck.vue?vue&type=template&id=35fe771e"
import script from "./IconDoubleCheck.vue?vue&type=script&lang=js"
export * from "./IconDoubleCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__